export default "__VITE_ASSET__DhCyGESx__"